<SvgIcon className="loading-spinner-icon {animate ? 'spin' : ''} {maskStyle ? 'mask-style' : ''}"
         style="width: {size}px; height: {size}px;"
         href="#fa-spinner"
         ariaLabel="{"Loading"}"
/>
<style>
  :global(.loading-spinner-icon) {
    fill: var(--svg-fill);
  }

  :global(.loading-spinner-icon.mask-style) {
    fill: var(--mask-svg-fill);
  }
</style>
<script>
  import SvgIcon from './SvgIcon.html'

  export default {
    data: () => ({
      maskStyle: false,
      size: 64,
      animate: true
    }),
    components: {
      SvgIcon
    }
  }
</script>
